const nt = {
  title: 'Northern Territory',
  links: [
    {
      anchorText: 'Darwin',
      searchAreaId: '29396',
      path: 'darwin-nt',
    },
    {
      anchorText: 'Alice Springs',
      searchAreaId: '29397',
      path: 'alice-springs-nt',
    },
    {
      anchorText: 'Palmerston',
      searchAreaId: '29555',
      path: 'palmerston-nt-0830',
    },
    {
      anchorText: 'Katherine',
      searchAreaId: '10712',
      path: 'katherine-nt-0850',
    },
    {
      anchorText: 'Nightcliff',
      searchAreaId: '15154',
      path: 'nightcliff-nt-0810',
    },
    {
      anchorText: 'Humpty Doo',
      searchAreaId: '10702',
      path: 'humpty-doo-nt',
    },
    {
      anchorText: 'Winnellie',
      searchAreaId: '15160',
      path: 'winnellie-nt-0820',
    },
    {
      anchorText: 'Howard Springs',
      searchAreaId: '10700',
      path: 'howard-springs-nt',
    },
    {
      anchorText: 'Gillen',
      searchAreaId: '14470',
      path: 'gillen-nt',
    },
    {
      anchorText: 'Nhulunbuy',
      searchAreaId: '10764',
      path: 'nhulunbuy-nt-0880',
    },
    {
      anchorText: 'Tennant Creek',
      searchAreaId: '10075',
      path: 'tennant-creek-nt-0860',
    },
    {
      anchorText: 'Dundee Beach',
      searchAreaId: '10660',
      path: 'dundee-beach-nt',
    },
    {
      anchorText: 'Casuarina',
      searchAreaId: '15153',
      path: 'casuarina-nt-0810',
    },
    {
      anchorText: 'Darwin City',
      searchAreaId: '28830',
      path: 'darwin-city-nt',
    },
    {
      anchorText: 'Berrimah',
      searchAreaId: '10625',
      path: 'berrimah-nt',
    },
    {
      anchorText: 'Karama',
      searchAreaId: '10711',
      path: 'karama-nt-0812',
    },
    {
      anchorText: 'Yarrawonga',
      searchAreaId: '10825',
      path: 'yarrawonga-nt',
    },
    {
      anchorText: 'Coconut Grove',
      searchAreaId: '10639',
      path: 'coconut-grove-nt',
    },
    {
      anchorText: 'Ciccone',
      searchAreaId: '14465',
      path: 'ciccone-nt',
    },
    {
      anchorText: 'Stuart Park',
      searchAreaId: '10792',
      path: 'stuart-park-nt',
    },
    {
      anchorText: 'Berry Springs',
      searchAreaId: '10626',
      path: 'berry-springs-nt',
    },
    {
      anchorText: 'Parap',
      searchAreaId: '15158',
      path: 'parap-nt-0820',
    },
    {
      anchorText: 'Virginia',
      searchAreaId: '10806',
      path: 'virginia-nt',
    },
    {
      anchorText: 'Yulara',
      searchAreaId: '10096',
      path: 'yulara-nt',
    },
    {
      anchorText: 'Malak',
      searchAreaId: '10732',
      path: 'malak-nt',
    },
    {
      anchorText: 'Acacia Hills',
      searchAreaId: '10603',
      path: 'acacia-hills-nt',
    },
    {
      anchorText: 'Leanyer',
      searchAreaId: '10725',
      path: 'leanyer-nt',
    },
    {
      anchorText: 'Pinelands',
      searchAreaId: '10775',
      path: 'pinelands-nt',
    },
    {
      anchorText: 'Coolalinga',
      searchAreaId: '10641',
      path: 'coolalinga-nt',
    },
    {
      anchorText: 'Pine Creek',
      searchAreaId: '10774',
      path: 'pine-creek-nt',
    },
    {
      anchorText: 'Marlow Lagoon',
      searchAreaId: '10739',
      path: 'marlow-lagoon-nt',
    },
    {
      anchorText: 'Wagaman',
      searchAreaId: '10809',
      path: 'wagaman-nt',
    },
    {
      anchorText: 'Braitling',
      searchAreaId: '14464',
      path: 'braitling-nt',
    },
    {
      anchorText: 'Wulagi',
      searchAreaId: '10823',
      path: 'wulagi-nt',
    },
    {
      anchorText: 'Bees Creek',
      searchAreaId: '10622',
      path: 'bees-creek-nt',
    },
    {
      anchorText: 'Batchelor',
      searchAreaId: '10618',
      path: 'batchelor-nt',
    },
    {
      anchorText: 'Zuccoli',
      searchAreaId: '10827',
      path: 'zuccoli-nt',
    },
    {
      anchorText: 'Wadeye',
      searchAreaId: '10807',
      path: 'wadeye-nt',
    },
    {
      anchorText: 'Gray',
      searchAreaId: '10687',
      path: 'gray-nt',
    },
    {
      anchorText: 'Adelaide River',
      searchAreaId: '10604',
      path: 'adelaide-river-nt',
    },
    {
      anchorText: 'Woolner',
      searchAreaId: '10822',
      path: 'woolner-nt',
    },
    {
      anchorText: 'Moil',
      searchAreaId: '10753',
      path: 'moil-nt',
    },
    {
      anchorText: 'Araluen',
      searchAreaId: '14462',
      path: 'araluen-nt',
    },
    {
      anchorText: 'Wagait Beach',
      searchAreaId: '10808',
      path: 'wagait-beach-nt-0822',
    },
    {
      anchorText: 'Jingili',
      searchAreaId: '10708',
      path: 'jingili-nt',
    },
    {
      anchorText: 'Gunn',
      searchAreaId: '10690',
      path: 'gunn-nt',
    },
    {
      anchorText: 'Noonamah',
      searchAreaId: '10766',
      path: 'noonamah-nt',
    },
    {
      anchorText: 'Tortilla Flats',
      searchAreaId: '10799',
      path: 'tortilla-flats-nt',
    },
    {
      anchorText: 'Farrar',
      searchAreaId: '10673',
      path: 'farrar-nt',
    },
    {
      anchorText: 'Gregory',
      searchAreaId: '15143',
      path: 'gregory-nt',
    },
    {
      anchorText: 'Bakewell',
      searchAreaId: '10615',
      path: 'bakewell-nt',
    },
    {
      anchorText: 'Wanguri',
      searchAreaId: '10813',
      path: 'wanguri-nt',
    },
    {
      anchorText: 'Larrakeyah',
      searchAreaId: '10723',
      path: 'larrakeyah-nt',
    },
    {
      anchorText: 'Archer',
      searchAreaId: '10612',
      path: 'archer-nt',
    },
    {
      anchorText: 'Rosebery',
      searchAreaId: '10784',
      path: 'rosebery-nt',
    },
    {
      anchorText: 'Connellan',
      searchAreaId: '14466',
      path: 'connellan-nt-0873',
    },
    {
      anchorText: 'White Gums',
      searchAreaId: '14478',
      path: 'white-gums-nt',
    },
    {
      anchorText: 'Marrakai',
      searchAreaId: '10737',
      path: 'marrakai-nt',
    },
    {
      anchorText: 'Millner',
      searchAreaId: '10747',
      path: 'millner-nt',
    },
    {
      anchorText: 'Knuckey Lagoon',
      searchAreaId: '10717',
      path: 'knuckey-lagoon-nt',
    },
    {
      anchorText: 'Elliott',
      searchAreaId: '10668',
      path: 'elliott-nt',
    },
    {
      anchorText: 'Charles Darwin',
      searchAreaId: '15167',
      path: 'charles-darwin-nt-0822',
    },
    {
      anchorText: 'Belyuen',
      searchAreaId: '10624',
      path: 'belyuen-nt-0822',
    },
    {
      anchorText: 'Durack',
      searchAreaId: '10664',
      path: 'durack-nt',
    },
    {
      anchorText: 'Nakara',
      searchAreaId: '10759',
      path: 'nakara-nt',
    },
    {
      anchorText: 'Driver',
      searchAreaId: '10659',
      path: 'driver-nt',
    },
    {
      anchorText: 'Bellamack',
      searchAreaId: '10623',
      path: 'bellamack-nt',
    },
    {
      anchorText: 'Borroloola',
      searchAreaId: '10630',
      path: 'borroloola-nt',
    },
    {
      anchorText: 'Darwin River',
      searchAreaId: '10657',
      path: 'darwin-river-nt',
    },
    {
      anchorText: 'Nyirripi',
      searchAreaId: '10058',
      path: 'nyirripi-nt',
    },
    {
      anchorText: 'Anula',
      searchAreaId: '10610',
      path: 'anula-nt',
    },
    {
      anchorText: 'The Gardens',
      searchAreaId: '10793',
      path: 'the-gardens-nt',
    },
    {
      anchorText: 'Sadadeen',
      searchAreaId: '14474',
      path: 'sadadeen-nt',
    },
    {
      anchorText: 'Arnold',
      searchAreaId: '15189',
      path: 'arnold-nt',
    },
    {
      anchorText: 'Herbert',
      searchAreaId: '10694',
      path: 'herbert-nt',
    },
    {
      anchorText: 'Tindal',
      searchAreaId: '10796',
      path: 'tindal-nt',
    },
    {
      anchorText: 'Cossack',
      searchAreaId: '10646',
      path: 'cossack-nt',
    },
    {
      anchorText: 'East Arm',
      searchAreaId: '10665',
      path: 'east-arm-nt',
    },
    {
      anchorText: 'Girraween',
      searchAreaId: '10684',
      path: 'girraween-nt',
    },
    {
      anchorText: 'Alawa',
      searchAreaId: '10605',
      path: 'alawa-nt',
    },
    {
      anchorText: 'Tiwi',
      searchAreaId: '10797',
      path: 'tiwi-nt',
    },
    {
      anchorText: 'Buffalo Creek',
      searchAreaId: '15133',
      path: 'buffalo-creek-nt',
    },
    {
      anchorText: 'Ludmilla',
      searchAreaId: '10729',
      path: 'ludmilla-nt',
    },
    {
      anchorText: 'Fannie Bay',
      searchAreaId: '10672',
      path: 'fannie-bay-nt',
    },
    {
      anchorText: 'Victoria River',
      searchAreaId: '10804',
      path: 'victoria-river-nt',
    },
    {
      anchorText: 'Mount Liebig',
      searchAreaId: '10051',
      path: 'mount-liebig-nt',
    },
    {
      anchorText: 'Lansdowne',
      searchAreaId: '10722',
      path: 'lansdowne-nt',
    },
    {
      anchorText: 'Timber Creek',
      searchAreaId: '10795',
      path: 'timber-creek-nt',
    },
    {
      anchorText: 'Tara',
      searchAreaId: '10074',
      path: 'tara-nt',
    },
    {
      anchorText: 'Marrara',
      searchAreaId: '10740',
      path: 'marrara-nt',
    },
    {
      anchorText: 'East Side',
      searchAreaId: '14468',
      path: 'east-side-nt',
    },
    {
      anchorText: 'Flynn',
      searchAreaId: '14469',
      path: 'flynn-nt',
    },
    {
      anchorText: 'Canteen Creek',
      searchAreaId: '10022',
      path: 'canteen-creek-nt',
    },
    {
      anchorText: 'Uralla',
      searchAreaId: '10802',
      path: 'uralla-nt',
    },
    {
      anchorText: 'Lloyd Creek',
      searchAreaId: '10728',
      path: 'lloyd-creek-nt',
    },
    {
      anchorText: 'Wurrumiyanga',
      searchAreaId: '28385',
      path: 'wurrumiyanga-nt',
    },
    {
      anchorText: 'Desert Springs',
      searchAreaId: '14467',
      path: 'desert-springs-nt',
    },
    {
      anchorText: 'Larapinta',
      searchAreaId: '10047',
      path: 'larapinta-nt',
    },
    {
      anchorText: 'Rapid Creek',
      searchAreaId: '10781',
      path: 'rapid-creek-nt',
    },
    {
      anchorText: 'Wishart',
      searchAreaId: '15186',
      path: 'wishart-nt',
    },
  ],
};

export { nt };
